import React, { useCallback, useState } from 'react';
import ReportsList from './ReportsList';
import TemplatesList from './TemplatesList';
import ContentBlocksList from './ContentBlocksList';
import { Button, ButtonGroup, Grid, Box } from '@mui/material';
import ReportSearch from "./ReportSearch";
import TemplateSearch from './TemplateSearch';
import ContentBlockSearch from './ContentBlockSearch';
import reportsSx from './Reports.styles';
import { useTheme } from '@mui/material/styles';



const Reports = () => {
	// Reports, layouts, contentBlocks
	const [ tab, setTab ] = useState('reports'),
		  theme           = useTheme(),
		  sx              = reportsSx(theme);

	const handleTabChange = useCallback((e) => {
		setTab(e.currentTarget.name);
	}, [ setTab ]);

	return (
		<div>
			<Grid container spacing={4}>
				<Grid size={{ xs: 12, lg: 3, xl: 4 }}>
					{tab === 'reports' && <ReportSearch />}
					{tab === 'layouts' && <TemplateSearch />}
					{tab === 'contentBlocks' && <ContentBlockSearch />}
				</Grid>

				<Grid size={{ xs: 12, lg: 9, xl: 8 }}>
					<Box sx={sx.buttonGroupContainer}>
						<ButtonGroup fullWidth variant="contained">

							<Button
								size="large"
								name="reports"
								onClick={handleTabChange}
								sx={tab === 'reports'
									? sx.buttonActive
									: sx.buttonInactive}
							>
								Reports
							</Button>

							<Button
								size="large"
								name="layouts"
								onClick={handleTabChange}
								sx={tab === 'layouts'
									? sx.buttonActive
									: sx.buttonInactive}
							>
								Layouts
							</Button>

							<Button
								size="large"
								name="contentBlocks"
								onClick={handleTabChange}
								sx={tab === 'contentBlocks'
									? sx.buttonActive
									: sx.buttonInactive}
							>
								Content Blocks
							</Button>

						</ButtonGroup>
					</Box>

					{tab === 'reports' && <ReportsList />}
					{tab === 'layouts' && <TemplatesList />}
					{tab === 'contentBlocks' && <ContentBlocksList />}
				</Grid>
			</Grid>
		</div>
	);
};


export default Reports;
